// extracted by css-extract-rspack-plugin
var _1 = "F2XKF";
var _2 = "aMihS";
var _3 = "OeChX";
export { _1 as "container", _2 as "detailsMessage", _3 as "mainMessage" }
